import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { DocumentViewerModalData } from '#src/interfaces'

export const useDocumentViewerStore = defineStore('documentViewerStore', () => {
  const isDocumentViewerModalOpen = ref(false)
  const document = ref<DocumentViewerModalData | null>(null)

  const openDocumentViewerModal = (data: DocumentViewerModalData) => {
    document.value = data
    isDocumentViewerModalOpen.value = true
  }

  const closeDocumentViewerModal = () => {
    isDocumentViewerModalOpen.value = false
    document.value = null
  }

  return {
    isDocumentViewerModalOpen,
    document,
    openDocumentViewerModal,
    closeDocumentViewerModal,
  }
})
